import PublicPageHeader from "@/components/PublicPageHeader";
import SiteFooter from "@/components/SiteFooter";

export default function LegalPageShell({ title, effectiveDate, lastUpdated, intro, sections, testId }) {
  return (
    <div className="bg-slate-50 text-slate-900">
      <PublicPageHeader />
      <main className="mx-auto max-w-3xl px-4 py-14 sm:px-6" data-testid={testId}>
        <h1 className="text-3xl font-semibold text-slate-900 sm:text-4xl" data-testid="legal-page-title">{title}</h1>
        {(effectiveDate || lastUpdated) && (
          <div className="mt-3 flex flex-wrap gap-4 text-xs text-slate-500">
            {effectiveDate && <span>Effective Date: {effectiveDate}</span>}
            {lastUpdated && <span>Last Updated: {lastUpdated}</span>}
          </div>
        )}
        {intro && <p className="mt-6 text-sm leading-relaxed text-slate-600 sm:text-base">{intro}</p>}

        <div className="mt-10 space-y-10">
          {sections.map((s, i) => (
            <section key={s.title || i} data-testid={`legal-section-${i}`}>
              <h2 className="flex items-baseline gap-2 text-lg font-semibold text-slate-900">
                {s.number && <span className="text-teal-700">{s.number}.</span>} {s.title}
              </h2>
              {s.paragraphs?.map((p, pi) => (
                <p key={`${pi}-${p}`} className="mt-2 text-sm leading-relaxed text-slate-600 sm:text-base">{p}</p>
              ))}
              {s.bullets && (
                <ul className="mt-3 list-inside list-disc space-y-1.5 text-sm text-slate-600 sm:text-base">
                  {s.bullets.map((b, bi) => (
                    <li key={`${bi}-${b}`}>{b}</li>
                  ))}
                </ul>
              )}
            </section>
          ))}
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}
